import React from 'react'
// Components --------------------------------
import MainContent from "../ui/ReviewComponents/MainContent"
const ReviewQueuePage = () => {
  return (
    <div className="flex h-screen overflow-hidden bg-background">
      <MainContent />
    </div>
  )
}

export default ReviewQueuePage